<template>
	<v-snackbar
		v-if="current"
		:key="current.id"
		:model-value="true"
		:timeout="current.timeout"
		:color="colors[current.type]"
		location="top"
		@update:model-value="onHide"
	>
		<div class="d-flex align-center">
			<v-progress-circular
				v-if="current.type === 'loading'"
				indeterminate
				size="18"
				width="2"
				class="mr-3"
			/>
			<v-icon v-else size="small" class="mr-2">{{ icons[current.type] }}</v-icon>
			<span>{{ current.content }}</span>
		</div>
	</v-snackbar>
</template>

<script>
import { messageState, message } from "@/plugins/message";

export default {
	name: "MessageHost",
	data() {
		return {
			colors: {
				success: "success",
				error: "error",
				warning: "warning",
				info: "info",
				loading: "secondary"
			},
			icons: {
				success: "mdi-check-circle",
				error: "mdi-close-circle",
				warning: "mdi-alert-circle",
				info: "mdi-information"
			}
		};
	},
	computed: {
		current() {
			return messageState.queue[0];
		}
	},
	methods: {
		onHide(visible) {
			if (!visible && this.current) message.dismiss(this.current.id);
		}
	}
};
</script>
